import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The two answers to "this slot's show is also used by screens you did not pick": update it on every linked screen, or make a copy for the
 * selected screens. A CONTROLLED pair of options - choosing one only highlights it (value/onChange); saving is the wizard's own «احفظ وشغّله».
 * Used inline in the save step (before saving) and, as the safety net, after the server answered 409 needs_scope_choice.
 *
 * Props: shared:{selected,other_screens,linked,linked_count}, slotName:string, value:null|'all'|'own', onChange:(scope)=>void, busy?:boolean
 */
export function ScopeOptions({ shared, slotName, value, onChange, busy = false }) {
  const { t } = useTranslation();
  const names = (list) => (list || []).map((s) => s.name).join('، ');

  return (
    <div data-testid="scope-options">
      <button type="button" className="fc-row" aria-pressed={value === 'all'} disabled={busy} onClick={() => onChange('all')} data-testid="scope-all">
        <span className="ic">🔁</span>
        <span className="b">
          <span className="t">{t('cafe_wizard.scope_all_title', { slot: slotName, count: shared.linked_count })}</span><br />
          <span className="s">{t('cafe_wizard.scope_all_desc', { screens: names(shared.linked) })}</span>
        </span>
      </button>

      <button type="button" className="fc-row" aria-pressed={value === 'own'} disabled={busy} onClick={() => onChange('own')} data-testid="scope-own">
        <span className="ic">➕</span>
        <span className="b">
          <span className="t">{t('cafe_wizard.scope_own_title')}</span><br />
          <span className="s">{t('cafe_wizard.scope_own_desc', { screens: names(shared.selected), others: names(shared.other_screens) })}</span>
        </span>
      </button>
    </div>
  );
}

/** The notice above the options: the show is shared, and with whom. */
export function ScopeNotice({ shared, slotName }) {
  const { t } = useTranslation();
  const others = (shared.other_screens || []).map((s) => s.name).join('، ');

  return (
    <div className="fc-warn" data-testid="scope-notice">
      <b>{t('cafe_wizard.scope_title')}</b><br />
      {t('cafe_wizard.scope_subtitle', { slot: slotName, others })}
    </div>
  );
}

/** The 409 safety net: the whole step, shown when the server asked although the save step did not. */
export default function ScopeChoice({ choice, value, onChange, busy = false }) {
  const { t } = useTranslation();

  return (
    <div data-testid="scope-choice">
      <div className="fc-p-t">{t('cafe_wizard.scope_title')}</div>
      <div className="fc-p-s">{t('cafe_wizard.scope_subtitle', { slot: choice.slot_name, others: (choice.other_screens || []).map((s) => s.name).join('، ') })}</div>
      <ScopeOptions shared={choice} slotName={choice.slot_name} value={value} onChange={onChange} busy={busy} />
      <div className="fc-inote">{t('cafe_wizard.scope_pick_hint')}</div>
    </div>
  );
}
